module.exports = {
  init: () => {
    $('.scrollbutton').on('click', function () {
      $('html,body').animate({ scrollTop: 0 }, 'slow')
      return false
    })

    function setButtonState () {
      let shouldBeVisible = $(window).scrollTop() > 500
      if (shouldBeVisible) {
        $('.scrollbutton').show()
      } else if (!shouldBeVisible) {
        $('.scrollbutton').hide()
      }
    }
    setButtonState()
    $(window).on('scroll', setButtonState)
  }
}
